import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import iconEdit from '../../../assets/icons/edit-black.svg'
import iconDelete from '../../../assets/icons/delete-black.svg'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import Pagination from '../../../components/pagination/pagination.component'
import PagesWorker from './pages'
import './pages.styles.scss'

class Pages extends React.Component {

    constructor() {
        super()
        this.pagesWorker = PagesWorker(this)
        this.state = this.pagesWorker.getDefaultState()
    }

    componentDidMount() {
        this.pagesWorker.loadPages()
    }

    onSearch = (event) => {
        event.preventDefault()
        this.setState({
            ...this.state,
            currentPage: 1
        }, () => this.pagesWorker.loadPages())
    }

    onPageChange = (page) => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.pagesWorker.loadPages())
    }

    onDelete = (id, title) => {
        const shouldDelete = window.confirm('Delete page "' + title + '"? This is a soft delete.')
        if (!shouldDelete) {
            return
        }

        this.pagesWorker.deletePage(id)
    }

    getTypeLabel = (type) => {
        switch (Number(type)) {
            case 0:
                return 'SYSTEM'
            case 1:
                return 'NEWS'
            default:
                return type
        }
    }

    renderEmpty = () => {
        if (this.state.loading || this.state.listError || this.state.pages.length > 0) {
            return null
        }

        return <div className="empty-state">No pages found.</div>
    }

    renderListError = () => {
        if (!this.state.listError) {
            return null
        }

        return (
            <div className="flag error pages-error">
                <div>{this.state.listError}</div>
                <button type="button" onClick={() => this.pagesWorker.loadPages()}>Retry</button>
            </div>
        )
    }

    render() {
        return (
            <div className="pages">
                {
                    this.state.loading && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/pages/create">New Page</Link>
                    <div className="header">
                        <h4>Pages</h4>
                    </div>

                    <div className={"flag " + this.state.flag.type}>{this.state.flag.text}</div>

                    <form className="search-form" onSubmit={this.onSearch}>
                        <div className="inputs">
                            <div className="row compact">
                                <div className="form-label">
                                    <label>Search</label>
                                </div>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        name="filter.value"
                                        value={this.state.filter.value}
                                        onChange={(event) => {
                                            const value = event.target.value
                                            this.setState({
                                                ...this.state,
                                                filter: {
                                                    ...this.state.filter,
                                                    value
                                                }
                                            })
                                        }}
                                        placeholder="Search by title"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="actions">
                            <button type="submit">Search</button>
                        </div>
                    </form>

                    {this.renderListError()}

                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Type</th>
                                    <th>URL</th>
                                    <th>Updated</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.pages.map((page, key) => {
                                        const updatedAt = page.updatedAt || page.updated
                                        return (
                                            <tr key={key}>
                                                <td>{page.title}</td>
                                                <td>{this.getTypeLabel(page.type)}</td>
                                                <td className="url-cell">{page.url || '-'}</td>
                                                <td>{updatedAt ? new Date(updatedAt).toLocaleString() : '-'}</td>
                                                <td>
                                                    <div className="actions">
                                                        <button type="button" className="text-action" onClick={() => this.props.history.push('/content/pages/view/' + page.id)}>View</button>
                                                        <img alt="" src={iconEdit} onClick={() => this.props.history.push('/content/pages/edit/' + page.id)} />
                                                        {
                                                            this.state.deletingId === page.id
                                                                ? <Loading />
                                                                : <img alt="" src={iconDelete} onClick={() => this.onDelete(page.id, page.title)} />
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        {this.renderEmpty()}
                    </div>

                    {
                        this.state.total > 0 && (
                            <Pagination
                                currentIndex={this.state.currentPage}
                                totalItemsCount={this.state.total}
                                itemsPerPage={this.state.pageSize}
                                onChange={this.onPageChange}
                            />
                        )
                    }
                </div>
            </div>
        )
    }
}

export default withRouter(Pages)
